import React from 'react';
import { Text } from '@react-pdf/renderer';

const Watermark = () =>
  <Text
    fixed
    style={{
      position: 'absolute',
      top: '40%',
      left: 0,
      right: 0,
      textAlign: 'center',
      fontSize: 150,
      fontWeight: 600,
      textTransform: 'uppercase',
      color: 'rgba(0, 0, 0, 0.2)',
      transform: 'rotate(-45deg)',
      fontFamily: 'Roboto',
    }}
  >
    RADNO
  </Text>
  ;

export default Watermark;
